import { render } from "./EditAbonnePage.vue?vue&type=template&id=b9594a22&ts=true"
import script from "./EditAbonnePage.vue?vue&type=script&lang=ts"
export * from "./EditAbonnePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__